// frontend/src/pages/PaymentCancel.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import './PaymentCancel.css';

function PaymentCancel() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div>
      <Navbar />
      <div className="payment-cancel-page">
        <div className="cancel-container">
          <div className="cancel-icon">✕</div>
          <h1>{t('payment.cancel.title', 'Betalning avbruten')}</h1>
          <p className="cancel-message">
            {t('payment.cancel.message', 'Din betalning avbröts. Inga kostnader har debiterats.')}
          </p>
          
          <div className="cancel-info">
            <p>
              {t('payment.cancel.info', 'Om du ändrar dig kan du alltid återvända och uppgradera senare.')}
            </p>
          </div>

          <div className="cancel-actions">
            <button onClick={() => navigate('/priser')} className="btn-primary">
              {t('payment.cancel.tryAgain', 'Se priser igen')}
            </button>
            <button onClick={() => navigate('/dashboard')} className="btn-secondary">
              {t('payment.cancel.goToDashboard', 'Tillbaka till Dashboard')}
            </button>
          </div>

          <div className="help-section">
            <h3>{t('payment.cancel.needHelp', 'Behöver du hjälp?')}</h3>
            <p>
              {t('payment.cancel.contact', 'Kontakta oss på')}{' '}
              <a href="mailto:support@moricome.com">support@moricome.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentCancel;
